<template>
  <div class="docs common-main">
    <div class="docs-header">
      <h3>{{ $t('docs_welcome') }}</h3>
      <div class="docs-header-desc">
        <div class="docs-header-desc-right">
          <Icon type="info" />
          <!-- <p>{{ $t('docs_introduce_title') }}</p> -->
          <p>
            {{ $t('docs_introduce') }}
          </p>
        </div>
      </div>
    </div>

    <!-- 搜索 -->
    <SearchForm
      :categoryList="categoryList"
      @search="onSearch"
      @change="onChange"
      @getCategoryValue="onCategoryCheck"
      v-if="AUTH_DOCS_SEARCH"
    />

    <div class="docs-list">
      <div class="docs-list-title">
        <h3>{{ $t('docs_help_title') }}</h3>

        <!-- 文档管理 -->
        <router-link
          :to="{
            name: 'DocsList',
          }"
          v-if="AUTH_DOCS_MANAGE"
        >
          <a-button type="primary">
            {{ $t('docs_manage_title') }}
          </a-button>
        </router-link>
      </div>
      <div class="docs-list-content" v-if="this.list && this.list.length > 0">
        <div
          class="docs-list-item"
          @click="toDetail(item.id)"
          v-for="item in this.list"
          :key="item.id"
        >
          <div class="docs-list-item-icon">
            <Icon type="docs-icon" />
          </div>
          <div class="docs-list-item-desc">
            <span>{{ item.title }}</span>
            <p>
              {{ item.intro }}
            </p>
          </div>
        </div>
      </div>
      <div class="docs-list-content" v-else>
        <Empty />
      </div>
    </div>
  </div>
</template>
<script>
import SearchForm from './components/SearchForm/';
import * as DocsAPI from '@/api/docs';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [docsAuth],
  components: {
    SearchForm,
  },
  name: 'Docs',
  data() {
    return {
      searchValue: '',

      // 分类列表
      categoryList: null,
      checkedValues: [],

      // 文档列表
      list: null,
      listAll: null,

      // 列表加载loading
      loading: false,
    };
  },
  created() {
    // 获取所有分类
    this.getAllDocuments();
  },
  methods: {
    searchList() {
      // 根据关键字，匹配listAll的title和intro字段
      this.list = this.listAll.filter(item => {
        const titleMatch = item.title
          ? item.title.toLowerCase().includes(this.searchValue.toLowerCase())
          : false;
        const introMatch = item.intro
          ? item.intro.toLowerCase().includes(this.searchValue.toLowerCase())
          : false;
        const categoryMatch = this.checkedValues.length
          ? this.checkedValues.includes(item.wikiCategoryId)
          : true;

        return (titleMatch || introMatch) && categoryMatch;
      });
    },

    // 获取所有列表
    getAllDocuments() {
      return DocsAPI.getAllDocuments()
        .then(res => {
          if (res.code === 0 && res.data) {
            const _categoryList = [];
            res.data?.categories.forEach(item => {
              item.value = item.id;
              item.label = item.name;
              _categoryList.push(item);
            });

            this.categoryList = _categoryList;
            this.listAll = res.data?.records || [];
            this.list = res.data?.records || [];
          }
        })
        .catch(() => {
          this.categoryList = null;
          this.list = null;
        })
        .finally(() => {
          // 结束页面加载;
          this.$store.commit('setPageLoading', false);
        });
    },

    // 跳转到详情
    toDetail(id) {
      this.$router.push({
        name: 'DocsDetail',
        params: { id },
      });
    },

    onCategoryCheck(checkedValues) {
      console.log('checkedValues', checkedValues);
      this.checkedValues = checkedValues || [];
      this.searchList();
    },

    onChange(e) {
      this.searchValue = trim(e.target.value);
      this.searchList();
    },

    // 全文搜索，跳转到搜索页面
    onSearch() {
      const query = {};
      if (this.searchValue) {
        query.keyword = this.searchValue;
      }
      if (this.checkedValues && this.checkedValues.length) {
        query.category = this.checkedValues.join(',');
      }

      this.$router.push({
        name: 'DocsSearch',
        query,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.docs {
  background: @g-layout-background;
  overflow-y: auto;
  border-radius: 12px;
  height: 100%;
  .docs-header {
    padding: 24px;
    border-radius: 12px;
    background: #fff;
    margin-bottom: 16px;
    h3 {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      margin: 0;
    }
    .docs-header-desc {
      display: flex;
      margin-top: 16px;
      .docs-header-desc-left {
        display: flex;
        align-items: flex-start;
        padding-right: 8px;

        svg {
          font-size: 24px;
          color: @primary-color;
          margin-top: 4px;
        }
      }

      .docs-header-desc-right {
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;

        p {
          color: var(--colorText, rgba(0, 0, 0, 0.88));
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin: 0;
        }
      }
    }
  }

  .docs-list {
    background: #fff;
    padding: 16px 24px 8px 24px;
    border-radius: 12px;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: calc(100% - 272px);
    height: auto;
    .docs-list-title {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .docs-list-content {
      display: flex;
      padding: 24px 0;
      flex-direction: row;
      align-items: flex-start;
      flex: 1 0 0;
      align-self: stretch;
      flex-wrap: wrap;
      justify-content: flex-start;

      .docs-list-item {
        display: flex;
        padding: 16px 24px;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: #f9f9fd;
        cursor: pointer;
        width: calc(25% - 24px);
        margin-right: 24px;
        margin-bottom: 24px;
        height: 106px;

        &:nth-child(4n) {
          margin-right: 0;
          width: 25%;
        }

        &:hover {
          box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
        }

        .docs-list-item-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            width: 46px;
            height: 46px;
            font-size: 24px;
            color: @primary-color;
          }
        }

        .docs-list-item-desc {
          width: 80%;
          span {
            color: #18181a;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            display: block;
            white-space: nowrap; /* 防止换行 */
            overflow: hidden; /* 隐藏超出部分 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
            margin-bottom: 8px;
          }

          p {
            color: #71717a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            margin: 0;
            display: -webkit-box; /* 必须加，用于支持多行截断 */
            -webkit-line-clamp: 2; /* 限制最多显示两行 */
            -webkit-box-orient: vertical; /* 设置块排列方向为垂直 */
            overflow: hidden; /* 隐藏超出部分 */
            text-overflow: ellipsis; /* 超出部分显示省略号 */
          }
        }
      }
    }
  }
}
</style>
